/**
 * ResultList 组件 - 搜索结果列表
 */

import React from 'react';
import { SearchResultItem } from './types';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'next-i18next';
import { IconHashtag, IconLocation } from '@/components/email-finder/icons';
import { cn } from '@/lib/utils';

// // Location 图标（地点图标）
// const LocationIcon = () => (
//   <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center">
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//       <path
//         d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
//         fill="#5B8DEF"
//       />
//     </svg>
//   </div>
// );
//
// // Hashtag 图标
// const HashtagIcon = () => (
//   <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center">
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//       <path
//         d="M20.25 7.5l-.625 5m.625-5h-2.5m2.5 0l.625-5m-.625 10h-2.5m0 0l-.625 5m.625-5h-6.25m6.25 0l.625-5m-6.875 5l-.625 5m.625-5h-6.25m6.25 0l.625-5m-6.875 10H3.75m2.5 0l-.625-5m.625 5l-.625 5M6.25 12.5h-2.5m2.5 0l.625-5m-.625 5l.625 5m0-10h6.25m-6.25 0L6.875 2.5M13.125 7.5l-.625 5m.625-5l.625-5"
//         stroke="#9333EA"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </div>
// );

interface ResultListProps {
  results: SearchResultItem[];
  highlightedIndex: number;
  onItemClick: (item: SearchResultItem, index: number) => void;
  onItemHover: (index: number) => void;
  isMobile?: boolean;
}

export const ResultList: React.FC<ResultListProps> = ({
  results,
  highlightedIndex,
  onItemClick,
  onItemHover,
  isMobile = false,
}) => {
  const { t } = useTranslation('common');

  if (results.length === 0) {
    return (
      <div className={`${isMobile ? 'py-10' : 'py-8'} text-center`}>
        <p className="text-[16px] text-[#999999] capitalize">{t('No results found')}</p>
      </div>
    );
  }

  return (
    <div className="w-full">
      {results.map((item, index) => {
        const isHighlighted = index === highlightedIndex;
        const isHashtag = item.type === 'hashtag';

        return (
          <div
            key={item.id}
            className={`
              flex items-center justify-between px-4 cursor-pointer transition-colors
              ${isMobile ? 'h-[68px]' : 'h-[64px]'}
              ${isHighlighted ? 'bg-[#f7fafe]' : 'hover:bg-[#f7fafe]'}
            `}
            onClick={() => onItemClick(item, index)}
            onMouseEnter={() => onItemHover(index)}
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div
                className={cn('w-8 h-8 flex items-center justify-center rounded-full', {
                  'bg-[#E5E1FF] text-[#725CFF]': isHashtag,
                  'bg-[#E1EDFC] text-[#3F92FF]': !isHashtag,
                })}
              >
                {isHashtag ? <IconHashtag /> : <IconLocation />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[16px] text-[#0c0c0c] capitalize truncate">{item.name}</p>
                {isHashtag && (
                  <p className="text-[14px] text-[#0c0c0c] opacity-60 capitalize truncate">{item.postCount}</p>
                )}
              </div>
            </div>
            <RightOutlined className="text-[#999] text-[14px] ml-2 flex-shrink-0" />
          </div>
        );
      })}
    </div>
  );
};
